/* eslint-disable */
import * as util from "@/api/product";

const state = {
    monthlyListArr: [],
    annuallyListArr: [],
    sixMonthListArr: [],
    freeListArr: [],
    smartListArr: [],
};

const mutations = {
     SET_smartListArr: (state, value) => {
        state.smartListArr = value
    },
    SET_freeListArr: (state, value) => {
        state.freeListArr = value
    },
    SET_monthlyListArr: (state, value) => {
        state.monthlyListArr = value
    },
    SET_annuallyListArr: (state, value) => {
        state.annuallyListArr = value
    },
    SET_sixMonthListArr: (state, value) => {
        state.sixMonthListArr = value
    }
};

const actions = {
    smartListPublic({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getPublicList(dataParams).then(response => {
                const { data } = response;
                commit('SET_smartListArr', data.data)
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    freeListPublic({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getPublicList(dataParams).then(response => {
                const { data } = response;
                commit('SET_freeListArr', data.data)
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sixMonthListPublic({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getPublicList(dataParams).then(response => {
                const { data } = response;
                commit('SET_sixMonthListArr', data.data)
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    monthlyListPublic({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getPublicList(dataParams).then(response => {
                const { data } = response;
                commit('SET_monthlyListArr', data.data)
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    annuallyListPublic({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getPublicList(dataParams).then(response => {
                const { data } = response;
                commit('SET_annuallyListArr', data.data)
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },

};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/product.js